import { FC, useState } from 'react';
import * as S from './styles';

export interface ActorFaceProps {
  facePictureSrc: string;
  name: string | null;
  className?: string;
}

export const ActorFace: FC<ActorFaceProps> = ({ facePictureSrc, name, className }) => {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);

  if (failedSrc === facePictureSrc) {
    return null;
  }

  return (
    <S.Frame
      className={className}
      data-testid="actor-face"
      {...(name ? { role: 'img', 'aria-label': name } : { 'aria-hidden': true })}
    >
      <S.FaceImage
        key={facePictureSrc}
        src={facePictureSrc}
        alt=""
        onError={() => setFailedSrc(facePictureSrc)}
        data-testid="actor-face-image"
      />
    </S.Frame>
  );
};
